export const NgxToastrConfig = {
    positionClass: 'toast-top-center'
};
